import DashboardsListSection from 'modules/ai_reports/components/DashboardsListSection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DashboardsListPage = () => {
  return (
    <ResponsivePage.Body variant="fullscreen">
      <DashboardsListSection />
    </ResponsivePage.Body>
  )
}

export default DashboardsListPage
